module.exports = __webpack_public_path__ + "img/home5.efd081a8.png";